import React from "react";
import { Link } from 'gatsby';

import FurtherReadingListItem from "./further-reading-list-item";

import "../../styles/essays/further-reading.scss";

class FurtherReadingList extends React.Component {
  constructor(props) {
    super(props);

    this.showAffiliateDisclaimer = this.showAffiliateDisclaimer.bind(this);
  }

  showAffiliateDisclaimer() {
    let show = false;

    this.props.items.forEach(item => {
      if (item.data.ASIN || item.data['US Bookshop'] || item.data['UK Bookshop']) {
        show = true;
      }
    });
    
    return show;
  }

  render () {
    const citationItems = this.props.items.filter(item => item.data.Type !== "Note");
    const noteItems = this.props.items.filter(item => item.data.Type === "Note");

    return (
      <>
        <ul className="further-reading">
          {noteItems.map((item, idx) => (
            <FurtherReadingListItem item={item} key={idx} />
          ))}
          {citationItems.map((item, idx) => (
            <FurtherReadingListItem item={item} key={idx} />
          ))}
        </ul>
        <div className="further-reading__disclaimer">
          <p>
            The Public Domain Review receives a small percentage commission from sales made via the links to Bookshop.org (10%) and Amazon (4.5%). Thanks for supporting the project! For more recommended books, see all our “<Link to="/further-reading">Further Reading</Link>” books, and browse our dedicated Bookshop.org stores for <a href="https://bookshop.org/shop/pdr-foa-bookshop" target="_blank" rel="noopener noreferrer">US</a> and <a href="https://uk.bookshop.org/shop/pdr-bookshop" target="_blank" rel="noopener noreferrer">UK</a> readers.
          </p>
        </div>
      </>
    );
  }
}

export default FurtherReadingList;